module.exports = __webpack_public_path__ + "img/icon03.7bf9640.png";